import { render, staticRenderFns } from "./AdminNamirniceTab.vue?vue&type=template&id=618d2e48"
import script from "./AdminNamirniceTab.vue?vue&type=script&lang=js"
export * from "./AdminNamirniceTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports